import LockIcon from "../../images/LockIcon.svg";
import GlobeIcon from "../../images/GlobeIcon.svg";
import ClownIcon from "../../images/ClownIcon.svg";

export const GETTING_STARTED_TEXT = {
    EXCITED_TEXT: 'Excited to have you on board. Create your online Knowledge Base and start providing your customers with the answers they want. ',
    CHOOSE_KB: 'Choose knowledge base access type',
    WELCOME_TEXT: 'Welcome to Hiver Knowledge Base!',
    SETUP_KB: 'Setup Knowledge Base',
    INTERNAL_DESCRIPTION: 'Internal is a private knowledge base and can only be accessed by your team',
    EXTERNAL_DESCRIPTION: 'External is public knowledge and can be accessed by everyone',
    INTERNAL: 'Internal',
    EXTERNAL: 'External',
    INTERNAL_ALT: 'InternalLogo',
    EXTERNAL_ALT: 'ExternalLogo',
    CLOWN_IMG_ALT: 'Higher Plan',
    UPGRADE: 'Upgrade',
}

export const CHOICE_DATA = [
    {
        ID: GETTING_STARTED_TEXT.INTERNAL.toLocaleLowerCase(),
        IMG: LockIcon,
        TYPE: GETTING_STARTED_TEXT.INTERNAL,
        DESCRIPTION: GETTING_STARTED_TEXT.INTERNAL_DESCRIPTION,
        IMG_ALT: GETTING_STARTED_TEXT.INTERNAL_ALT,
        CLOWN_IMG: ClownIcon,
        CLOWN_IMG_ALT: GETTING_STARTED_TEXT.CLOWN_IMG_ALT,
    },
    {
        ID: GETTING_STARTED_TEXT.EXTERNAL.toLocaleLowerCase(),
        IMG: GlobeIcon,
        TYPE: GETTING_STARTED_TEXT.EXTERNAL,
        DESCRIPTION: GETTING_STARTED_TEXT.EXTERNAL_DESCRIPTION,
        IMG_ALT: GETTING_STARTED_TEXT.EXTERNAL_ALT
    }
];

export const EDITOR = 'editor';
export const VIEWER = 'viewer';
export const FEATURE_FLAG_INTERNAL_KB = 'ftr-internal-kb';

export const GAINSIGHT_EVENTS = {
    SETUP_KB: 'setupKB',
    BRANDING_DONE: 'brandingDone',
    USERS_ADDED: 'kbUsersAdded',
    SITE_SETTING_ADDED: 'siteSettingsAdded',
    GOTO_DASHBOARD: 'goToKBDashboardAfterSetup'
};

export const NO_KB_EXISTS = 'Knowledge Base does not exists';
export const FEATURE_FLAG_NEW_AUTH = 'rls-newauth-kb-service';
